import React from 'react';
import BidOffer from '../pages/BidOffer';

export const bidOfferRoutePage = {
  component: <BidOffer />,
  route: '/oferta-de-lance',
};
